import { render, staticRenderFns } from "./FuBox.vue?vue&type=template&id=2016009b&scoped=true"
import script from "./FuBox.vue?vue&type=script&lang=js"
export * from "./FuBox.vue?vue&type=script&lang=js"
import style0 from "./FuBox.vue?vue&type=style&index=0&id=2016009b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016009b",
  null
  
)

export default component.exports